/*
    <field-interest value="data.interest"></field-interest>

    // or field for js form
        {
            name: 'interest',
            title: 'Interest',
            type: 'field',
            field: 'interest'
        },

*/
(function () {
    var component = {
        template: "\n            <div class=\"row\">\n                <div class=\"col-xs-6\" ng-repeat=\"i in options()\">\n                    <label>\n                        <input type=\"checkbox\" ng-model=\"field.chosen[i.id]\" ng-change=\"onChange()\" /> {{i.name}}\n                    </label>\n                </div>\n            </div>\n            <div class=\"row\" ng-show=\"!showAll\">\n                <div class=\"col-xs-12\">\n                    <a href style=\"color: #0fa2e8; font-weight: bold;\" ng-click=\"showMore()\">{{'Show / select more interest areas' | translate}}</a>\n                </div>\n            </div>\n        ",
        link: function (DI) {
            var _this = this;
            this.field = {
                chosen: {}
            };
            var setter = DI.prop('value', function (value) {
                if (!Array.isArray(value))
                    return;
                for (var id in _this.field.chosen)
                    _this.field.chosen[id] = false;
                value.forEach(function (id) { return _this.field.chosen[id] = true; });
            }, { setter: true });
            var all = [];
            this.showAll = false;
            DI.Data.load('interest').then(function (result) {
                all = result.sort(function (a, b) {
                    return a.name < b.name ? -1 : 1;
                });
            });
            this.options = function () {
                if (_this.showAll)
                    return all;
                return all.filter(function (i) { return i.top || _this.field.chosen[i.id]; });
            };
            this.showMore = function () { return _this.showAll = true; };
            this.onChange = function () {
                var result = [];
                for (var id in _this.field.chosen) {
                    if (_this.field.chosen[id])
                        result.push(Number(id));
                }
                setter(result);
            };
        }
    };
    gs.component('fieldInterest', component);
    gs.component('fieldInterestNoFrame', component);
})();
